import { Dispatch } from 'react';
import { TFunction } from 'i18next';
import { VariantType } from 'notistack';
import { TServiceClientActionTypes } from '../types';
import { SET_LOADING } from 'src/contexts/types';
import { handleError } from 'src/contexts/utils/handleError';
import { UPDATE_SERVICE_CLIENT } from '../constants/actions';
import { HEADERS } from 'src/constants/headers';
import { ApiV2 } from 'src/api/apiv2';
import { IServiceClient } from 'src/interfaces/serviceClient';

export type TUpdateServiceClientDeps = {
    t: TFunction;
    customAlert: (
        message: string,
        variant?: VariantType,
        options?: Record<string, unknown>,
        actionUrl?: string,
        playSound?: boolean
    ) => void;
};

export type TUpdateServiceClientOptions = {
    playSound?: boolean;
};

export const updateServiceClient = async (
    dispatch: Dispatch<TServiceClientActionTypes>,
    serviceClientId: string,
    values: Record<string, unknown>,
    deps: TUpdateServiceClientDeps,
    options?: TUpdateServiceClientOptions
): Promise<Partial<IServiceClient> | undefined> => {
    const { t, customAlert } = deps;
    const playSound = options?.playSound !== false;

    dispatch({ type: SET_LOADING });
    try {
        const res = await ApiV2.put(
            `/service-clients/${serviceClientId}/update`,
            { ...values },
            HEADERS({
                isReadPermissionNecessary: false,
            })
        );

        dispatch({
            type: UPDATE_SERVICE_CLIENT,
            payload: res.data.data,
        });

        customAlert(t('SnackBar.ServiceClientUpdated'), 'success', {}, undefined, playSound);

        return res.data.data;
    } catch (error) {
        if (error instanceof Error) dispatch(handleError(error));
    }
};
